import { render, staticRenderFns } from "./AccountBasic.vue?vue&type=template&id=8bee5a30&"
import script from "./AccountBasic.vue?vue&type=script&lang=js&"
export * from "./AccountBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports